import React, { ForwardedRef, forwardRef, TextareaHTMLAttributes } from 'react';
import cn from 'classnames';

import styles from './textarea.module.scss';

interface ITextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {

}

function Textarea(props: ITextareaProps, ref: ForwardedRef<HTMLTextAreaElement>) {
  const { className, ...restProps } = props;

  return (
    <textarea
      {...restProps}
      ref={ref}
      className={cn(styles.textarea, className)}
    />
  );
}

export default forwardRef(Textarea);